import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import LayoutOne from "../layouts";
import Breadcrumb from "../components/UI/breadcrumb";

const About = () => {
    return (
        <Fragment>
            <MetaTags>
                <title>Adaptive Systems LLC | Refund Policy</title>
                <meta
                    name="description"
                    content=""
                />
            </MetaTags>
            <LayoutOne>
                <Breadcrumb title="Refund Policy" />
                <div className="container pt--60 pb--60">
                    <h4>Effective Date: 07 july 2025 </h4>
                    <p>At Adaptive Systems LLC, we aim to provide high-quality internet, cable TV, and home phone services to all our customers. If you are not fully satisfied with our services, this Refund Policy outlines the circumstances under which you may be eligible for a refund.</p>

                    <h4>1. Eligibility for Refund</h4>
                    <p>You may be eligible for a refund under the following circumstances:</p>
                    <ul>
                        <li>Service Cancellation: If you cancel your service before the billing cycle begins, you may receive a full refund for any charges paid in advance.</li>
                        <li>Service Downtime: If your service experiences an extended period of unavailability (more than 48 hours) due to technical issues on our end, you may qualify for a refund or credit for the affected period.</li>
                        <li>Billing Errors: If you are incorrectly billed for services (e.g., charged an incorrect rate), you are eligible for a refund for any overcharges.</li>
                    </ul>

                    <h4>2. Non-Refundable Charges</h4>
                    <p>The following charges are non-refundable:</p>
                    <ul>
                        <li>Setup or installation fees, unless otherwise stated in your service agreement.</li>
                        <li>Late payment fees or penalties resulting from delayed payments.</li>
                        <li>Subscription or promotional discounts that require a specific term commitment.</li>
                        <li>Payments for services already rendered up to the cancellation date.</li>
                    </ul>


                    <h4>3. How to Request a Refund</h4>
                    <p>If you believe you are eligible for a refund, please contact our customer support team at info@adaptivesystems-llc.com.</p>
                    <h4>Include the following details in your refund request:</h4>
                    <ul>
                        <li>Your account information (name, address, account number).</li>
                        <li>A description of the issue or reason for your refund request.</li>
                        <li>Proof of payment (e.g., receipt or billing statement).</li>
                    </ul>
                    <p>We aim to respond to all refund requests within 7-10 business days. Once your request is reviewed, we will notify you regarding its status.</p>


                    <h4>4. Refund Method</h4>
                    <p>Refunds will typically be issued to the original payment method used during the transaction. If that is not possible, we may offer an alternative refund method, such as a check or credit to your account, at our discretion.</p>
                
                
                <h4>5. Refund Processing Time</h4>
                <p>Refunds will generally be processed within 14 business days from the approval of your request. Please allow additional time for your bank or payment provider to process the refund.</p>


                <h4>6. Changes to This Refund Policy</h4>
                <p>Adaptive Systems LLC reserves the right to modify or update this Refund Policy at any time. Any changes will be posted on our website and will apply to all future transactions. We encourage you to review the policy periodically for updates.</p>

                <h4>Contact Us</h4>
                <p>Adaptive Systems LLC reserves the right to modify or update this Refund Policy at any time. Any changes will be posted on our website and will apply to all future transactions. We encourage you to review the policy periodically for updates.</p>
                
                <h4>Contact Us</h4>
                <p>If you have any questions or need assistance with your refund request, please contact us at:</p>
                
                
                <h5>Adaptive Systems LLC</h5>
                <p>Email: info@adaptivesystems-llc.com</p>
                <p>Mailing Address: 2420 Kates Pl ,Prosper, TX 75078</p>
                
                </div>
            </LayoutOne>
        </Fragment>
    );
};

export default About;
